export function IconMapPin({ className }) {
  return (
    <svg viewBox="0 0 15 21" className={className}>
      <path
        d="M6.998 20a.366.366 0 0 1-.28-.13c-.275-.322-6.7-7.892-6.7-11.73a7.22 7.22 0 0 1 2.05-5.051A6.927 6.927 0 0 1 7.017.996c1.856 0 3.636.753 4.948 2.093a7.22 7.22 0 0 1 2.05 5.051c0 3.838-6.444 11.4-6.7 11.73a.372.372 0 0 1-.317.13Zm0-18.24a6.193 6.193 0 0 0-4.42 1.87A6.456 6.456 0 0 0 .744 8.14c0 3.12 5.003 9.382 6.254 10.895 1.25-1.52 6.254-7.767 6.254-10.895a6.456 6.456 0 0 0-1.834-4.51 6.193 6.193 0 0 0-4.42-1.87Z"
        fill="currentColor"
      />
      <path
        d="M6.998 11.88a3.607 3.607 0 0 1-2.033-.628 3.72 3.72 0 0 1-1.35-1.675 3.808 3.808 0 0 1-.21-2.158 3.76 3.76 0 0 1 1-1.914 3.637 3.637 0 0 1 1.872-1.024 3.59 3.59 0 0 1 2.114.21c.67.282 1.241.76 1.644 1.375a3.791 3.791 0 0 1-.452 4.715 3.626 3.626 0 0 1-2.585 1.098Zm0-6.7c-.577 0-1.14.173-1.62.5-.48.326-.855.791-1.076 1.335a3.033 3.033 0 0 0-.166 1.72c.112.577.39 1.108.797 1.524.408.417.928.7 1.494.815a2.86 2.86 0 0 0 1.684-.17A2.928 2.928 0 0 0 9.42 9.805a3.02 3.02 0 0 0-.364-3.755 2.885 2.885 0 0 0-2.057-.871Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function IconArrowRight({ className }) {
  return (
    <svg viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M.01 7.015h18.612M12.618 13.02l6.004-6.005-6.004-6.004" stroke="#fff" strokeWidth="1.272" />
    </svg>
  )
}

export function IconArrowTopRight({ className }) {
  return (
    <svg viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="m4.735 17.596 13.161-13.16M17.896 12.926V4.435h-8.49" stroke="#fff" strokeWidth="1.272" />
    </svg>
  )
}

export function IconMapMarker({ className }) {
  return (
    <svg viewBox="0 0 65 96" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M32.213.5c17.48 0 31.714 14.234 31.714 31.713 0 12.575-5.228 20.51-11.821 30.518-1.556 2.362-3.188 4.839-4.845 7.52L32.212 94.425 17.166 70.251c-1.657-2.681-3.29-5.158-4.845-7.52C5.728 52.723.5 44.788.5 32.213.5 14.734 14.734.5 32.213.5Zm18.255 30.445c0-9.91-8.081-18.255-18.255-18.255-10.172 0-18.255 8.345-18.255 18.255 0 10.168 8.087 18.255 18.255 18.255s18.255-8.087 18.255-18.255Z"
        fill="url(#brand-svg-gradient)"
        stroke="#fff"
      />
    </svg>
  )
}

export function IconFitlerGroupOpen({ className }) {
  return (
    <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M0 8a8 8 0 0 1 8-8h14v14a8 8 0 0 1-8 8H0V8Z" fill="#00853C" />
      <path
        d="M18.075 11.25a.833.833 0 0 1-.843.844h-5.625v5.625c0 .492-.387.879-.844.879-.492 0-.844-.387-.844-.88v-5.624H4.294c-.492 0-.844-.352-.844-.809 0-.492.352-.879.844-.879H9.92V4.781c0-.457.352-.808.844-.808.457 0 .844.351.844.808v5.625h5.625c.457 0 .843.387.843.844Z"
        fill="#fff"
      />
    </svg>
  )
}

export function IconFitlerGroupClose({ className }) {
  return (
    <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M0 8a8 8 0 0 1 8-8h14v14a8 8 0 0 1-8 8H0V8Z" fill="#00853C" />
      <path
        d="M18.449 11.393a.833.833 0 0 1-.844.844H4.667c-.492 0-.843-.352-.843-.809 0-.492.351-.879.843-.879h12.938c.457 0 .844.387.844.844Z"
        fill="#fff"
      />
    </svg>
  )
}
